export const agencyData = obj => ({
    type: 'AGENCY_DATA',
    obj
})